import React from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Button,
} from '@mui/material';
import { Edit, Add } from '@mui/icons-material';
import { AUTH_LEVELS } from '../../auth/Authorized';
import { beginEditingRole, beginNewRole } from '../../../redux/actions/users';
import { getAllDisplayRoles } from '../../../redux/selectors/users';

import './roles-table.css';

const RolesTable = ({
  roles,
  beginEditing,
  newRole,
  canCreate,
  editType,
  editingId,
  scrollTop,
}) => (
  <div className="role-table">
    {canCreate ? (
      <div className="new-role">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            scrollTop();
            newRole();
          }}
        >
          <Add />
          Create new Role
        </Button>
      </div>
    ) : null}
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Edit</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Type</TableCell>
          <TableCell>Org</TableCell>
          <TableCell>Description</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {roles.map((role) => (
          <TableRow
            className="role-row"
            key={role.id}
            hover
            selected={editType === 'ROLE' && editingId === role.id}
            classes={{ selected: 'active' }}
          >
            <TableCell>
              <IconButton
                onClick={() => {
                  scrollTop();
                  beginEditing(role.id);
                }}
                size="large"
              >
                <Edit />
              </IconButton>
            </TableCell>
            <TableCell>{role.name}</TableCell>
            <TableCell>{role.type.name}</TableCell>
            <TableCell>{role.org.name}</TableCell>
            <TableCell>{role.description}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

export default connect(
  ({
    users: {
      roles,
      roleTypes,
      organizations,
      editing: { editType, id },
    },
    user: { userAuthLevel },
  }) => ({
    roles: getAllDisplayRoles(roles, roleTypes, organizations),
    editType,
    editingId: id,
    canCreate: userAuthLevel === AUTH_LEVELS.SUPER_ADMIN,
  }),
  (dispatch) => ({
    beginEditing: (id) => dispatch(beginEditingRole(id)),
    newRole: () => dispatch(beginNewRole()),
  })
)(RolesTable);
